module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"newVacancy":"New job"}}')
  delete Component.options._Ctor
}
